/**
  * @class meleImage
  * @description
  *
  * # Purpose
  * Implements `<mele-image>` custom web element.
  *
  * # Use
  * Create element in HTML:
  * ```
  * parentEl.innerHTML += '<mele-image></mele-image>';
  * ```
  * Create element in JavaScript:
  * ```
  * var el = elParent.appendChildren({
  *   tag: 'mele-image',
  *   icon: 'plain_plus',
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleElement from 'meleElement'

const PROPERTIES = _.extend({}, {
  icon: { type: 'string', description: 'name of built-in icon for image' },
  data: { type: 'string', description: 'raw data in base64 type' },
  dimensions: { type: 'array', description: 'width and height of the image' },
  color: { description: 'color of the image; useful for icons', type: 'string' },
}, meleElement._properties)

export default class meleImage extends meleElement {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "icon"
  */
  iconChanged() {
    if(typeof (this.data)==='string' && this.data.length>0) {
      this.innerHTML = '<img src="'+this.data+'" />'
      this.clearDependencies('data')
      this.clearDependencies('icon')
    }else{
      this.innerHTML = ''
      const elIcon = this.getImageAndSetDependencies(this.icon, 'icon')
      if(elIcon) { this.appendChild(elIcon) }
    }
  } // iconChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "icon"
  */
  dataChanged(value) {
    this.iconChanged()
  } // dataChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "dimensions"
  */
  dimensionsChanged(value) {
    if(Array.isArray(value) && value.length == 2) {
      const [width, height] = value
      this.style.width = width + 'px'
      this.style.height = height + 'px'
    }
  } // dimensionsChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "color"
  */
  colorChanged(value) {
    let className = this.className.replace(/\bcolor-\S+/, '')
    const color = this.translateAndSetDependencies(value, false, 'color')
    if(color!='') className += ' color-'+color
    this.className =
      className
        .replace(/\s+/g, ' ')
        .replace(/^\s+/, '')
        .replace(/\s+$/, '')
  } // colorChanged
} // class meleImage

meleImage._properties = PROPERTIES
meleImage.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-image', meleImage)
